export {Colors} from './Colors';
export {viewStyles, textStyles, viewColors} from './CommonStyles';
